import { render, staticRenderFns } from "./FacilitatorInstructions.vue?vue&type=template&id=4e567e3b"
import script from "./FacilitatorInstructions.vue?vue&type=script&lang=js"
export * from "./FacilitatorInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports